// Shared by the student and coach plans pages: what picking another plan does.

export const isYearly = (plan) => plan?.BillingFrequency === 'yearly';
export const priceSuffix = (plan) => (isYearly(plan) ? '/yr' : '/mo');
export const money = (n) => `$${Number(n || 0).toFixed(2)}`;
// A date from the server (YYYY-MM-DD or a full timestamp) as "Oct 23, 2026"
export const day = (d) => (d ? new Date(String(d).length === 10 ? `${d}T00:00:00` : d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '');

// Price per month, so a yearly plan compares fairly with a monthly one
export const perMonth = (plan) => Number(plan?.Price || 0) / (isYearly(plan) ? 12 : 1);

export const isFreePlan = (plan) => Number(plan?.Price) === 0 && !plan?.TrialDays;

// What a pick does for someone who pays by card (the backend's plan_change_kind, Evan,
// Sep 9): a dearer plan or yearly instead of monthly starts now, prorated; a cheaper one or
// monthly instead of yearly starts when the paid period ends; the same price switches now
export function changeKind(current, target) {
    const now = Number(current?.Price || 0);
    const next = Number(target?.Price || 0);
    if (next <= 0) return 'downgrade';
    if (now > 0 && isYearly(current) !== isYearly(target)) return isYearly(target) ? 'upgrade' : 'downgrade';
    if (next !== now) return next > now ? 'upgrade' : 'downgrade';
    return 'switch';
}

// What a plan card's button says: for someone who pays by card the backend's rule
// (Upgrade, Downgrade, Switch at the same price), else by price per month (Upgrade, or
// Subscribe at checkout; a covered student just subscribes); the free plan is a Downgrade
export function actionLabel(membership, plan, { paysByCard, covered } = {}) {
    if (!membership) return 'Subscribe';
    if (isFreePlan(plan)) return 'Downgrade';
    if (paysByCard) return { upgrade: 'Upgrade', downgrade: 'Downgrade', switch: 'Switch' }[changeKind(membership, plan)];
    return !covered && perMonth(plan) > perMonth(membership) ? 'Upgrade' : 'Subscribe';
}
